import dayjs from "dayjs";

export const categorizeEvents = (events: any) => {
    const today = dayjs().startOf('day');

    return {
        today: events.filter((i: any) => (dayjs(i.startDate).isSame(today, 'date')) ||
            dayjs(i.startDate).isBefore(today, 'date') && dayjs(i.endDate).isSameOrAfter(today, 'date'))
        ,
        upcoming: events.filter((i: any) => dayjs(i.startDate).isAfter(today, 'date')),
        passed: events.filter((i: any) => dayjs(i.startDate).isBefore(today, 'date'))
    };
};

export const mapApiRecord = (record: any) => {
    const todayDate = dayjs();

    return {
        today: record.filter((i: any) => dayjs(i.startDate).isSame(todayDate, 'date')),
        upcoming: record.filter((i: any) => dayjs(i.startDate).isAfter(todayDate, 'date')),
        passed: record.filter((i: any) => dayjs(i.startDate).isBefore(todayDate, 'date'))
    }

};

export const getNameObject = (fullName: string) => {
    if (!fullName) return {};
    const parts = fullName.split(" ");
    return {
        firstName: parts[0],
        lastName: parts.slice(1).join(" ")
    };
};

export const getThumbnailId = (event: any) => {
    return event?.profilePhoto?.thumbnails?.small?.id;
};
